import { CommonDialogContext } from '@/context/CommonDialogContext';
import { useContext } from 'react';

export const useDialogs = () => useContext(CommonDialogContext);
